<template>
  <div class="modelguidance-container">
    <div
      class="step-box"
      v-if="currentStep === 1">
      <div
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step1-guide-bg'
            : 'light-step1-guide-bg'
        "
        class="step1-guide-bg"></div>
      <div class="step-guide-box step1">
        <p class="title">新手引导</p>
        <div class="content">
          <div>注意哦，这里有两个分组：【模型管理】和【模型组管理】</div>
          <div style="margin-left: -6px">
            【模型管理】分组下的文件只支持<span class="height-color"
              >单个模型</span
            >查看
          </div>
          <div style="margin-left: -6px">
            【模型组管理】分组下的文件支持多个模型<span class="height-color"
              >组合</span
            >查看
          </div>
          <div class="common-button-box">
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 2">
      <div
        class="step2-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step2-guide-bg'
            : 'light-step2-guide-bg'
        "></div>
      <div class="step-guide-box step2 step2-guide-box">
        <p class="title">新手引导</p>
        <div class="content">
          <div>在<span class="height-color">【模型管理】</span>分组下</div>
          <div>第一步，我们点击这里上传模型文件</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 3">
      <div
        class="step3-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step3-guide-bg'
            : 'light-step3-guide-bg'
        "></div>
      <div class="step-guide-box2 step3">
        <p class="title">新手引导</p>
        <div class="content">
          <div>第二步，上传成功的模型需要提交转换才可查看哦</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="nextStep"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="step-box"
      v-if="currentStep === 4">
      <div
        class="step4-guide-bg"
        :class="
          $theme.get().value === 'dark'
            ? 'dark-step4-guide-bg'
            : 'light-step4-guide-bg'
        "></div>
      <div class="step-guide-box step4">
        <p class="title">新手引导</p>
        <div class="content">
          <div>第三步，模型转换成功后，点击模型名称即可查看模型</div>
          <div class="common-button-box">
            <el-button
              class="normal-btn"
              :class="$theme.get().value === 'dark' ? 'dark-btn' : ''"
              size="mini"
              @click="previousStep"
              >上一步</el-button
            >
            <el-button
              type="primary"
              class="primary-btn"
              size="mini"
              @click="start"
              >开始使用</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentStep: 1,
      steps: [1]
    }
  },
  props: {
    disableModelGuidance: Function
  },
  methods: {
    previousStep() {
      this.currentStep--
    },
    nextStep() {
      this.currentStep++
      if (!this.steps.includes(this.currentStep)) {
        this.steps.push(this.currentStep)
      }
    },
    start() {
      this.disableModelGuidance()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.modelguidance-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;

  .step-box {
    height: 100%;

    .light-step1-guide-bg {
      background: url('@/assets/user-guidance/model-step1.png') no-repeat;
    }

    .dark-step1-guide-bg {
      background: url('@/assets/user-guidance/dark-model-step1.png') no-repeat;
    }

    .step1-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .dark-step2-guide-bg {
      background: url('@/assets/user-guidance/dark-model-step2.png') no-repeat;
    }

    .light-step2-guide-bg {
      background: url('@/assets/user-guidance/model-step2.png') no-repeat;
    }

    .step2-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .light-step3-guide-bg {
      background: url('@/assets/user-guidance/model-step3.png') no-repeat;
    }

    .dark-step3-guide-bg {
      background: url('@/assets/user-guidance/dark-model-step3.png') no-repeat;
    }

    .step3-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .light-step4-guide-bg {
      background: url('@/assets/user-guidance/model-step4.png') no-repeat;
    }

    .dark-step4-guide-bg {
      background: url('@/assets/user-guidance/dark-model-step4.png') no-repeat;
    }

    .step4-guide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .step-guide-box {
      position: absolute;
      width: 382px;
      padding: 16px;
      color: #222222;
      background: var(--guides-bgColor);
      text-align: left;
      border-radius: 5px;

      &::after {
        position: absolute;
        display: block;
        border-color: transparent;
        border-style: solid;
        content: ' ';
        border-width: 6px;
        top: -5px;
        margin-left: 25px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }
    .step2-guide-box {
      &::after {
        right: -9px;
        top: 25px;
        transform: rotate(90deg);
      }
    }
    .step-guide-box2 {
      position: absolute;
      width: 382px;
      padding: 10px 20px;
      color: #222222;
      background: var(--guides-bgColor);
      text-align: left;
      border-radius: 5px;

      &::after {
        position: absolute;
        display: block;
        border-color: transparent;
        border-style: solid;
        content: ' ';
        border-width: 6px;
        top: -5px;
        margin-left: 300px;
        border-top-width: 0;
        border-bottom-color: #ffffff;
      }
    }

    .title {
      font-size: 18px;
      font-weight: bold;
    }

    .content {
      font-size: 14px;
      margin-top: 5px;
      line-height: 23px;
    }

    .height-color {
      color: var(--base-primary-bgColor);
    }

    .common-button-box {
      margin-top: 12px;
      text-align: right;

      .dark-btn {
        background: transparent;
        color: #777;
        border: 1px solid #777;
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }

    @media (max-width: 1920px) {
      .step1 {
        top: 236px;
        left: calc(13% + 1px);
      }
      .step2 {
        bottom: 114px;
        left: calc(38% - 32px);
      }
      .step3 {
        top: calc(36% + 6px);
        right: 7%;
      }

      .step4 {
        top: calc(36% + 6px);
        left: 35%;
      }
    }

    @media (min-height: 950px) {
      .step2 {
        bottom: 156px;
      }

      .step3 {
        top: calc(36% - 32px);
      }

      .step4 {
        top: calc(36% - 32px);
      }
    }

    @media (min-width: 1921px) {
      .step1 {
        top: 285px;
        left: 325px;
      }

      .step2 {
        bottom: 310px;
        left: calc(50% + 200px);
      }

      .step3 {
        top: 385px;
        right: 160px;
      }

      .step4 {
        top: 390px;
        left: 755px;
      }
    }

    @media (min-width: 2560px) {
      .step1 {
        top: 285px;
        left: 325px;
      }

      .step2 {
        bottom: 310px;
        left: calc(50% + 200px);
      }

      .step3 {
        top: 410px;
        right: 295px;
      }

      .step4 {
        top: 415px;
        left: 840px;
      }
    }

    @media (max-width: 1520px) {
      .step1 {
        top: 188px;
        left: 197px;
      }

      .step2 {
        bottom: 164px;
        left: calc(33% - 30px);
      }

      .step3 {
        top: 264px;
        right: 107px;
      }

      .step4 {
        top: 268px;
        left: 520px;
      }
    }

    @media (max-width: 1350px) {
      .step1 {
        top: 170px;
        left: 175px;
      }

      .step2 {
        bottom: 200px;
        left: calc(50% + 205px);
      }

      .step3 {
        top: 240px;
        right: 20px;
      }

      .step4 {
        top: 240px;
        left: 485px;
      }
    }
  }
}
</style>
